module.exports = __webpack_public_path__ + "static/media/add-language.5f1e69cf.png";